import React from "react";
import { useHistory } from "react-router-dom";
import Button, { ButtonThemes } from "../../../ui-components/button/button";
import { Routes } from "../../../app/route/RoutesConfig";
import "./pickupManagement.scss";

export interface BolResultBlockProps {
  bolNumber: string;
};

const BolOuterResultBlock: React.FC<BolResultBlockProps> = (props) => {
  const history = useHistory();

  return (
    <div className="xgs-pickup-assignment__outer-pickup-block">
      <div>
        <p>The BOL with number {props.bolNumber} was found without using filters and without taking into account the selected terminal, but it cannot be displayed within the&nbsp;pickup&nbsp;assignment&nbsp;process.</p>
        <p>To view information about this BOL, click &quot;View BOL&quot;.</p>
      </div>
      <Button
        theme={ButtonThemes.blue}
        type="submit"
        className="xgs-pickup-assignment__outer-pickup-block__button"
        onClick={() =>
          history.push(`${Routes.pickup.log}/${props.bolNumber}?fromBolSearch=true`)
        }
      >
      View BOL
    </Button>
    </div >
  );
};

export default BolOuterResultBlock;
